import React, { FC } from 'react';

import { LucidTheme, mqMax } from '@lucid/theme';

import Box from '../../box/box';
import Text from '../../text/text';
import Heading from '../../heading/heading';
import ComparisonCard, { ComparisonCardItemType } from './comparison-card';

export interface ComparisonCardGroupProps {
  /** Heading for Comparison Card Group */
  heading?: string;
  /** Subtitle for Comparison Card Group */
  subheading?: string;
  /** An list of Comparison Cards */
  comparisonCards?: ComparisonCardItemType[];
}

const ComparisonCardGroup: FC<ComparisonCardGroupProps> = ({ heading, subheading, comparisonCards }) => (
  <>
    <Box
      css={(theme: LucidTheme) => ({
        maxWidth: '680px',
        textAlign: 'center',
        margin: 'auto',
        marginBottom: theme.space.s80,
      })}
    >
      {heading && <Heading variant="headline3XL">{heading}</Heading>}
      {subheading && <Text variant="paragraphM400">{subheading}</Text>}
    </Box>
    <Box
      css={{
        maxWidth: '1100px',
        margin: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-around',
        [mqMax.tabletLandscape]: {
          flexDirection: 'column',
          alignItems: 'center',
        },
      }}
    >
      {comparisonCards?.map((card, index) => (
        <ComparisonCard key={`card-${index}`} card={card} />
      ))}
    </Box>
  </>
);

export default ComparisonCardGroup;
export { ComparisonCardGroup };
